module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"no":"No","yes":"Si","attention":"¡Atención!"},"en":{"no":"No","yes":"Yes","attention":"Attention!"}}')
  delete Component.options._Ctor
}
